module.exports = __webpack_public_path__ + "images/videoCaseStudy-urbanPartnershipBank-whyus-photo-02.jpg?h=57d555031b1980a08b9e00ef595c2b72";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/urbanPartnershipBank/videoCaseStudy-urbanPartnershipBank-whyus-photo-02.jpg
// module id = 2130
// module chunks = 12 15